import React, { useCallback, useMemo, useEffect, useState } from 'react'
import { Typography } from '../../components'
import * as S from './styles'
import Checked from '../../assets/Icons/checkedIcon.svg'

const NewStepper = ({ stepIcons, filling, hideSteps }) => {
  const initialData = useMemo(
    () =>
      [...Array(stepIcons.length).keys()].map((i) => ({
        step: i + 1,
        active: false,
        checked: false
      })),
    [stepIcons]
  )
  const [data, setData] = useState(initialData)

  const handleChangeFilling = useCallback(
    (fill) => {
      const updatedData = initialData
        .map((item) => (item.step <= fill ? { ...item, active: true } : item))
        .map((item) => (item.step < fill ? { ...item, checked: true } : item))
      setData(updatedData)
    },
    [initialData]
  )

  useEffect(() => {
    handleChangeFilling(filling)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filling])

  return (
    <S.Stepper>
      {data.map(({ step, active, checked }, idx) => {
        const { icon: Icon, label } = stepIcons[step - 1]
        return (
          <S.StepContainer
            key={step}
            display={hideSteps?.includes(step) ? 'none' : 'flex'}
          >
            {checked ? (
              <>
                {idx < data.length - 1 && <S.Line />}
                <img src={Checked} alt="checked" />
              </>
            ) : (
              <S.Circle filling={active} />
            )}
            <Icon color={active ? '#BE9137' : '#C4C4C4'} />
            <Typography
              type="label"
              color="#7D7987"
              weight={active ? 'bold' : 'normal'}
            >
              {label}
            </Typography>
          </S.StepContainer>
        )
      })}
    </S.Stepper>
  )
}

export default NewStepper
